import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";


export default function WorkflowButtons({ order, setOrder }) {
    const navigate = useNavigate();
    const { dispatch, user } = useAuthContext();
    const [error, setError] = useState(false);


    console.log("USER", user)
 

    const updateStatus = (status) => {
        // Load the order details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/${order.id}/${status}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                setOrder(res.data);
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
                if (err.response.status === 403) {
                    setError(true)
                }
            });
    }

    console.log("Status", order.status)

    if (order.status == "In Progress")
        return (<button className="btn btn-primary" onClick={() => { updateStatus("MarkSubmitted") }}>Mark Submitted</button>)

    // Not used until invoices implemented
    //if (order.status == "Submitted" && user.role == "Admin")
    //    return (
    //        <div>
    //            <button className="btn btn-primary" onClick={() => { updateStatus("MarkPaid") }}>Mark Paid</button>
    //            <div id="error" className="alert alert-danger" style={{ display: error == "" ? "none" : "" }}>You do not have permission to mark this order as paid</div>
    //        </div>
    //    )


    
}
